

export default function setUserSettings(settings, storage) {
  return storage.setItem('reactPerfToolSettings', JSON.stringify(settings));
}



/** WEBPACK FOOTER **
 ** ./src/utils/setUserSettings.js
 **/